import Cyber from "components/templates/cyber/Cyber";
import elementsTypes from "utils/elementsTypes";

export default {
  key: "CYBER",
  label: "17Cyber",
  Component: Cyber,
  initialContents: [
    {
      key: "firstDynamicPart",
      type: elementsTypes.DYNAMIC,
      value: "",
      children: [],
    },
    {
      key: "secondDynamicPart",
      type: elementsTypes.DYNAMIC,
      value: "",
      children: [],
    },
  ],
};
